import { render } from "./BPagination.vue?vue&type=template&id=5dd4a133&scoped=true&ts=true"
import script from "./BPagination.vue?vue&type=script&lang=ts"
export * from "./BPagination.vue?vue&type=script&lang=ts"

import "./BPagination.vue?vue&type=style&index=0&id=5dd4a133&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd4a133"]])

export default __exports__